import React from 'react';
import NotesMainPanel from '../../components/workspace/NotesMainPanel';
import { useDashboardData } from '../../components/DashboardShell';
import { useLocale } from '../../context/LocaleContext';

export default function SettingsIntegrationsPage() {
  const { data } = useDashboardData();
  const { t } = useLocale();
  const items = data?.workspace?.integrations || [];
  return (
    <NotesMainPanel
      title={t('settingsPages.integrationsTitle')}
      subtitle={t('settingsPages.integrationsSubtitle')}
      items={items}
      emptyTitle={t('settingsPages.integrationsEmpty')}
    />
  );
}
